<template>
  <b-container fluid>
    <loader :watch="['visnetHub', 'substationVisnetHub']">
      <div class="form-view col-xl-8">
        <b-alert v-if="!!error" variant="danger">{{ error }}</b-alert>
        <h2 class="mq">{{ title }}</h2>
        <b-form ref="form" lazy-validation novalidate @submit.prevent="submit">
          <b-form-group label="Name">
            <b-form-input v-model="visnetHubForm.name" />
          </b-form-group>
          <b-form-group label="Location details">
            <b-form-input v-model="visnetHubForm.locationDetails" />
          </b-form-group>
          <b-form-group class="form-group__buttons">
            <router-link
              :to="{
                name: 'substationDevices',
                params: {
                  projectCode,
                  substationCode: $route.params.substationCode
                }
              }"
              class="btn btn-link font-weight-bold"
            >
              Cancel
            </router-link>
            <b-button type="submit" :disabled="$v.visnetHubForm.$invalid" variant="rounded">
              Save
              <Icon name="save" />
            </b-button>
          </b-form-group>
        </b-form>
      </div>
    </loader>
  </b-container>
</template>

<script>
import merge from 'lodash/merge';
import forOwn from 'lodash/forOwn';
import { required } from 'vuelidate/lib/validators';

const isServerSideValid = function isServerSideValid() {
  return this.responseErrors.indexOf('code') === -1;
};

export default {
  name: 'VisnetHubForm',
  props: {
    title: String,
    mainError: Object,
    projectCode: String,
    visnetHub: {
      id: String,
      name: String,
      externalVisnetHubId: String,
      locationDetails: String,
      systemHealth: Number,
      alarmTimestamp: Number,
      alarmState: String,
      createdAt: String,
      updatedAt: String,
      substation: {
        name: String,
        code: String,
        projectCode: String
      }
    },
    inputsErrors: Array
  },
  data() {
    return {
      error: this.mainError,
      responseErrors: [],
      visnetHubForm: ''
    };
  },
  validations() {
    if (this.inputsErrors && this.inputsErrors.length) {
      const fieldsToValidate = { visnetHubForm: {} };

      forOwn(this.visnetHubForm, (val, key) => {
        fieldsToValidate.visnetHubForm[key] = { isServerSideValid };
        return true;
      });
      merge(fieldsToValidate.visnetHubForm.name, { required });

      return fieldsToValidate;
    }

    return {
      visnetHubForm: {}
    };
  },
  watch: {
    visnetHub(visnetHub) {
      this.updateVisnetHubFormData(visnetHub);
    },
    mainError(value) {
      this.error = value;
    },
    inputErrors(errors) {
      errors.forEach(error => this.addErrorToInput(error));
    }
  },
  mounted() {
    this.updateVisnetHubFormData(this.visnetHub);
  },
  methods: {
    submit() {
      const { substation, ...rest } = this.visnetHubForm;
      this.$emit('submit', { ...rest });
    },
    updateVisnetHubFormData(visnetHub) {
      if (visnetHub) {
        this.visnetHubForm = visnetHub;
      }
    },
    removeResponseErrors() {
      if (this.responseErrors.length > 0) {
        this.responseErrors = [];
        this.$v.$reset();
      }

      if (this.error) {
        this.error = '';
      }
    },
    handleInputField(fieldName) {
      const input = this.$v.visnetHubForm[fieldName];

      this.removeResponseErrors(fieldName);
      input.$touch();
    },
    addErrorToInput(error) {
      const [inputName, errorCode] = error.code.match(/(.*)\.(.*)/);
      const input = this.$v.visnetHubForm[inputName];

      if (input) {
        const errorMessage = this.errorMessage(inputName, errorCode) || error.details;

        this.responseErrors.push(inputName);
        input.invalidMessage = errorMessage;
        input.$touch();
      }
    }
  }
};
</script>
